var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMaestroIcon = function SvgMaestroIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4801 26.7963H17.4961V3.2041H30.4801V26.7963Z",
    fill: "#7375CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.336 15C18.336 10.2184 20.544 5.9466 24 3.20388C21.48 1.18932 18.288 0 14.832 0C6.648 0 0 6.7233 0 15C0 23.2767 6.648 30 14.832 30C18.288 30 21.48 28.8107 24 26.7961C20.544 24.0534 18.336 19.7816 18.336 15Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15C48 23.2767 41.352 30 33.168 30C29.712 30 26.52 28.8107 24 26.7961C27.456 24.0534 29.664 19.7816 29.664 15C29.664 10.2184 27.456 5.9466 24 3.20388C26.52 1.18932 29.712 0 33.168 0C41.352 0 48 6.7233 48 15Z",
    fill: "#00A2E5"
  })));
};
export default SvgMaestroIcon;